import React from 'react';
import type { CardMetric } from '@ctd/agent-contract';
import { formatMetricValue, formatRatioParts } from '../utils/card-format';
import { DeltaChip } from './delta-chip';
import style from '../style.module.scss';

/** One primary metric of a card: its label, unless the title already says it, then the content. */
export const MetricBlock: React.FC<{
    metric: CardMetric;
    title: string;
    children: React.ReactNode;
}> = ({ metric, title, children }) => (
    <div className={style.metric}>
        {metric.label !== title && (
            <span className={`${style.metric_label} footnote_description`}>
                {metric.label}
            </span>
        )}
        {children}
    </div>
);

/** A metric's value, with a rate's numerator and denominator beneath it. */
export const MetricValue: React.FC<{ metric: CardMetric }> = ({ metric }) => (
    <>
        <span className={`${style.metric_value} h3_medium`}>
            {formatMetricValue(metric)}
        </span>
        {metric.unit === 'ratio' && metric.ratio && (
            <span className={style.metric_ratio}>
                {formatRatioParts(metric.ratio)}
            </span>
        )}
    </>
);

export const MetricFigures: React.FC<{ metric: CardMetric }> = ({ metric }) =>
    metric.compare ? (
        <>
            <div className={style.compare_sides}>
                <div className={style.metric}>
                    <span
                        className={`${style.metric_label} footnote_description`}
                    >
                        Current
                    </span>
                    <MetricValue metric={metric} />
                </div>
                <div className={style.metric}>
                    <span
                        className={`${style.metric_label} footnote_description`}
                    >
                        Compared
                    </span>
                    <span className={`${style.compare_value} h3_medium`}>
                        {formatMetricValue({
                            unit: metric.unit,
                            value: metric.compare.value,
                        })}
                    </span>
                </div>
            </div>
            <DeltaChip metric={metric} compare={metric.compare} />
        </>
    ) : (
        <MetricValue metric={metric} />
    );
